import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { IconCycle } from 'utils/icons';
import './audit-status-cell-renderer.scss';

type Props = Partial<ICellRendererParams>;

export default function AuditStatusCellRenderer({
  data = {},
}: Props): JSX.Element {

  let value = '';
  let className = 'status ';

  if (data.status === '200 OK') {
    className += 'success';
    value = 'Success';
  } else {
    className += 'failed';
    value = 'Failed';
  }

  return (
    <span className="audit-status-cell-renderer">
      <span className={className} title={value}><IconCycle /></span>
      {value}
    </span>
  );
}
